import React, { useState,useEffect } from "react";
import { Link,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import { ChangeMobileFormat, ChangeMobileNumber, ExecuteLogoutBranch,LoginAfterCheckLogin,isNull } from "../../components/common/Common";
import "../../css/style.css";

//정보수정
const BranchInfo = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검
  const  navigate = useNavigate();
  const branch_idx = Number(localStorage.getItem('branch_idx'));

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varBranchInfo,setBranchInfo] = useState({});

  //결제 정보 목록
  const GetBranchInformation = async() => {
    const sendData = {branch_idx:branch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_my_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setBranchInfo(datas.results[0]);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});

    GetBranchInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //입력값 조정
  const onChangeInputHandler = (e) => {
    const { name,value } = e.currentTarget;
    if(name === "bh_mobile") {
      setBranchInfo({...varBranchInfo,bh_mobile:ChangeMobileNumber(value)});
    } else {
      setBranchInfo({...varBranchInfo,[name]:value});
    }
  }

  const onLogoutHandler = (e) => {
    ExecuteLogoutBranch();
    navigate('/MainBranch');
  }

  const onWithdrawHandler = (e) => {
    if(window.confirm('회원탈퇴 신청을 하시겠습니까?')) {
      alert('회원 탈퇴 신청이 완료되었습니다. 관리자에서 확인 후 처리 됩니다.');
      ExecuteLogoutBranch();
      navigate('/Branch/login');
    }
  }

  const onUpdateBranchInfoHandler = async(e) => {
    if(!isNull(varBranchInfo.bh_pwd1)) {
      if(varBranchInfo.bh_pwd1.length !== 4) {
        alert('비밀번호는 4자리로 입력하셔야 합니다. 재입력하십시오.');
        setBranchInfo({...varBranchInfo,bh_pwd1:"",bh_pwd2:""})
        return false;
      } else if(varBranchInfo.bh_pwd1 !== varBranchInfo.bh_pwd2) {
        alert('비밀번호와 확인 비밀번호가 서로 다릅니다. 재입력하십시오.');
        setBranchInfo({...varBranchInfo,bh_pwd1:"",bh_pwd2:""})
        return false;
      }
    }

    if(!window.confirm('센터 정보를 저장하시겠습니까?')) return false;

    const sendData = {datainfo:varBranchInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_my_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        navigate('/Branch/Operating');
      } else {
        alert(datas.message);
      }
    });
  }

  return (
    <div className="vh-content oper-wrap">
      <HeaderBranchTitle varPageTitle={'정보수정'} varBackString={'/Branch/Operating'}/>
      <div className="vh-content-body">
        <div className="oper-form-wrap">
          <div className="form-group mb15">
            <label className="form-label">센터명</label>
            <div className="field-group">
              <input type="text" name="bh_company" placeholder="센터명을 입력하세요." value={varBranchInfo.bh_company||""} className="form-control" onChange={e=>onChangeInputHandler(e)}/>
            </div>
          </div>
          <div className="form-group mb15">
            <label className="form-label">성명</label>
            <div className="field-group">
              <input type="text" name="bh_name" placeholder="이름을 입력하세요." value={varBranchInfo.bh_name||""} className="form-control" onChange={e=>onChangeInputHandler(e)}/>
            </div>
          </div>
          <div className="form-group mb15">
            <label className="form-label">아이디</label>
            <div className="field-group">
              <input type="text" name="bh_id" value={varBranchInfo.bh_id||""} className="form-control read-txt" disabled/>
            </div>
          </div>
          <div className="form-group mb15">
            <label className="form-label">연락처 ('-' 제외 숫자만 입력)</label>
            <div className="field-group">
              <input type="text" name="bh_mobile" placeholder="-없이 숫자만 입력하세요." value={ChangeMobileFormat(varBranchInfo.bh_mobile)} className="form-control" onChange={e=>onChangeInputHandler(e)}/>
            </div>
          </div>
          <div className="form-group mb15">
            <label className="form-label">비밀번호 (4자리 입력)</label>
            <div className="field-group">
              <input type="password" name="bh_pwd1" placeholder="새로운 비밀번호를 입력하세요" maxLength={4} value={varBranchInfo.bh_pwd1||""} className="form-control" onChange={e=>onChangeInputHandler(e)}/>
            </div>
          </div>
          <div className="form-group mb25">
            <label className="form-label">비밀번호 확인</label>
            <div className="field-group">
              <input type="password" name="bh_pwd2" placeholder="비밀번호를 재입력하세요" maxLength={4} value={varBranchInfo.bh_pwd2||""} className="form-control" onChange={e=>onChangeInputHandler(e)}/>
            </div>
          </div>
          
          <div className="logout-btn">
            <button onClick={e=>onWithdrawHandler(e)} style={{border:"none",background:"none",textDecoration:"underline",marginRight:"10px"}}>회원탈퇴</button>
            <button onClick={e=>onLogoutHandler(e)} style={{border:"none",background:"none",textDecoration:"underline"}}>로그아웃</button>
          </div>
          
          <div className="form-contoller bt-btn">
            <Link to={'/Branch/Operating'} className="form-contoller-btn btn-no" style={{width:"48%"}}>취소</Link>
            <button className="form-contoller-btn btn-yes" style={{borderRadius:"14px"}} onClick={e=>onUpdateBranchInfoHandler(e)}>수정</button>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default BranchInfo;